
import { Component, Vue } from 'vue-property-decorator';
import { setI18nLanguage } from '@/i18n';

@Component
export default class LocaleSwitch extends Vue {
  locale = 'ru';

  locales = [
    {
      icon: 'country-russia',
      value: 'ru',
    },
    {
      icon: 'country-uk',
      value: 'en',
    },
  ];

  get selectedLocale() {
    return this.locales.find((l) => l.value === this.locale);
  }

  handleClick(locale: (typeof this.locales)[0]) {
    this.locale = locale.value;
    setI18nLanguage(this.locale);
  }

  beforeMount() {
    this.locale = this.$i18n.locale;
  }
}
